module.exports = __webpack_public_path__ + "static/media/2025_60NGreenland.42628dad.png";